import $ from 'jquery';

$(() => {
  if ($('.menu-bar').length > 0) {
    const menuBarText = $('.menu-bar').find('span');
    const mainNav = $('.main-nav');
    const menuBar = $('.menu-bar');

    menuBar.on('click', () => {
      menuBar.toggleClass('open');
      $('.bar').toggleClass('animate');
      $('.menu-content').toggleClass('show-menu');
      if (menuBar.hasClass('open')) {
        menuBarText.html('close');
        mainNav.addClass('hide-nav');
      } else {
        menuBarText.html('menu');
        mainNav.removeClass('hide-nav');
      }
    });
  }
});



/** WEBPACK FOOTER **
 ** ./src/js/mobile-navigation.js
 **/